var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.11, written by Peter Selinger 2001-2013\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#FFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1910 2751 l0 -2091 -235 0 -235 0 0 201 0 201 -32 -7 c-18 -3 -85 -20 -148 -37 -374 -101 -561 -260 -499 -425 15 -42 85 -109 164 -158 170 -105 515 -195 865 -225 148 -13 552 -13 700 0 350 30 695 120 865 225 79 49 149 116 164 158 15 39 14 101 -3 140 -21 51 -131 144 -221 187 -173 82 -472 157 -720 180 -66 6 -139 13 -163 16 l-42 5 2 1051 3 1052 685 348 c377 192 688 353 693 357 5 5 -1771 887 -1834 909 -5 2 -9 -824 -9 -2087z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4239 1106 c-56 -20 -103 -52 -148 -101 -157 -171 -97 -449 117 -548 37 -17 67 -21 142 -22 89 0 99 2 158 34 123 67 186 170 186 306 0 67 -4 90 -28 142 -37 81 -111 152 -189 181 -67 25 -180 29 -238 8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/app-icon.afced26462ccc95d4d3e38d0ae50d6bb.svg";
export { ForwardRef as ReactComponent };